<div class="p-4">
  <form class="needs-validation" (ngSubmit)="onSubmit()" [formGroup]="workSitesForm">
    <div class="col-12 border-content p-2 my-2">
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'GENERAL.nameOfSite'
                        |
                        translate}} </label>
                    <input type="text" class="form-control" formControlName="nameOfSite">
                    <div *ngIf="workSitesForm.get('nameOfSite').dirty && workSitesForm.get('nameOfSite').errors"
                        class="invalid-feedback">
                        <span *ngIf="workSitesForm.get('nameOfSite').errors.required">This
                            value is
                            required.</span>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-lg-6">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'GENERAL.COUNTRY' |
                        translate}} </label>
                    <ng-select [items]="ListOfCountries" formControlName="country_Id"
                        class="form-control ng-select-customization" (change)="getListOfStates($event?.id)"
                        bindLabel="name" bindValue="id"></ng-select>
                </div>
            </div>

            <div class="col-xl-4 col-lg-6">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'GENERAL.STATES' |
                        translate}}</label>
                    <ng-select [items]="listOfStates" formControlName="state_Id"
                        class="form-control ng-select-customization" (change)="getListOfRegions($event?.id)"
                        bindLabel="name" bindValue="id"></ng-select>
                </div>
            </div>

            <div class="col-xl-4 col-lg-6">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'GENERAL.REGION' |
                        translate}}</label>
                    <ng-select class="form-control ng-select-customization" [items]="listOfRegion"
                        formControlName="region_Id" bindLabel="name" bindValue="id"></ng-select>
                    <div *ngIf="workSitesForm.get('region_Id').dirty && workSitesForm.get('region_Id').errors"
                        class="invalid-feedback">
                        <span *ngIf="workSitesForm.get('region_Id').errors.required">This value is
                            required.</span>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-lg-6">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'clients.numOfEmployees'
                        |
                        translate}} </label>
                    <input type="number" class="form-control" formControlName="numOfEmployees">
                    <div *ngIf="workSitesForm.get('numOfEmployees').dirty && workSitesForm.get('numOfEmployees').errors"
                        class="invalid-feedback">
                        <span *ngIf="workSitesForm.get('numOfEmployees').errors.required">This
                            value is
                            required.</span>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-lg-6">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'clients.numOfShifts'
                        |
                        translate}} </label>
                    <input type="number" class="form-control" formControlName="numOfShifts">
                    <div *ngIf="workSitesForm.get('numOfShifts').dirty && workSitesForm.get('numOfShifts').errors"
                        class="invalid-feedback">
                        <span *ngIf="workSitesForm.get('numOfShifts').errors.required">This
                            value is
                            required.</span>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-lg-6">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'GENERAL.POSTALCODE'
                        |
                        translate}} </label>
                    <input type="text" class="form-control" formControlName="postalCode">
                    <div *ngIf="workSitesForm.get('postalCode').dirty && workSitesForm.get('postalCode').errors"
                        class="invalid-feedback">
                        <span *ngIf="workSitesForm.get('postalCode').errors.required">This
                            value is
                            required.</span>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-lg-6">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'DETAILSTEXT.clientAddresses.streetAddress1' |
                        translate}}</label>
                    <input type="text" class="form-control" formControlName="streetAddress1">
                    <div *ngIf="workSitesForm.get('streetAddress1').dirty && workSitesForm.get('streetAddress1').errors"
                        class="invalid-feedback">
                        <span *ngIf="workSitesForm.get('streetAddress1').errors.required">This value is
                            required.</span>
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-lg-6">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'DETAILSTEXT.clientAddresses.streetAddress2' |
                        translate}}</label>
                    <input type="text" class="form-control" formControlName="streetAddress2">
                    <div *ngIf="workSitesForm.get('streetAddress2').dirty && workSitesForm.get('streetAddress2').errors"
                        class="invalid-feedback">
                        <span *ngIf="workSitesForm.get('streetAddress2').errors.required">This value is
                            required.</span>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'DETAILSTEXT.addressInDetails' |
                        translate}}</label>
                    <input type="text" class="form-control" formControlName="addressInDetails">
                    <div *ngIf="workSitesForm.get('addressInDetails').dirty && workSitesForm.get('addressInDetails').errors"
                        class="invalid-feedback">
                        <span *ngIf="workSitesForm.get('addressInDetails').errors.required">This value is
                            required.</span>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="mb-3">
                    <label class="form-label text-capitalize">{{'GENERAL.NOTES' |
                        translate}}</label>
                    <textarea type="text" class="form-control" formControlName="note"></textarea>
                    <div *ngIf="workSitesForm.get('note').dirty && workSitesForm.get('note').errors"
                        class="invalid-feedback">
                        <span *ngIf="workSitesForm.get('note').errors.required">This value is
                            required.</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="w-100 text-center">
        <button class="btn btn-primary" type="submit">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2" *ngIf="loadingWorkSite"></i>
            {{!lableForm ? 'ADD': 'EDIT'}}
        </button>
        <!-- <button class="btn btn-primary" type="submit">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2" *ngIf="loadingWorkSite"></i>
            {{!lableForm ? 'ADD': 'EDIT'}}
        </button> -->
    </div>
  </form>
</div>
